"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUTTON_CATEGORY_KEY = 'base';
exports.BUTTON_PARENT_COMPONENT_KEY = 'contextMenu';
exports.BUTTON_COMPONENT_KEY = 'button';